/**
 * ViewSwitcher — the [ Existing · List · Board · Calendar · Map ] pill row
 * for the Leads "Lenses" pilot (AD-046). Default = Existing (locked L-1).
 * Pure presentational: it owns no data, just the active-view choice.
 */

export type LensView = 'existing' | 'list' | 'board' | 'calendar' | 'map';

export const LENS_VIEWS: Array<{ key: LensView; label: string }> = [
  { key: 'existing', label: 'Existing' },
  { key: 'list', label: 'List' },
  { key: 'board', label: 'Board' },
  { key: 'calendar', label: 'Calendar' },
  { key: 'map', label: 'Map' },
];

export default function ViewSwitcher({
  active,
  onChange,
}: {
  active: LensView;
  onChange: (v: LensView) => void;
}) {
  return (
    <div
      role="tablist"
      aria-label="Leads views"
      style={{
        display: 'inline-flex',
        gap: 0,
        border: '1px solid var(--rule-strong, #D1D5DB)',
        borderRadius: 'var(--r-pill, 999px)',
        overflow: 'hidden',
        fontWeight: 700,
        fontSize: 12.5,
        background: 'var(--paper, #fff)',
      }}
    >
      {LENS_VIEWS.map((v, i) => {
        const on = v.key === active;
        return (
          <button
            key={v.key}
            type="button"
            role="tab"
            aria-selected={on}
            onClick={() => onChange(v.key)}
            style={{
              padding: '6px 15px',
              border: 'none',
              borderLeft: i === 0 ? 'none' : '1px solid var(--rule, #E5E7EB)',
              background: on ? 'var(--accent, #008069)' : 'transparent',
              color: on ? '#fff' : 'var(--ink-soft, #4B5563)',
              cursor: 'pointer',
              whiteSpace: 'nowrap',
            }}
          >
            {v.label}
          </button>
        );
      })}
    </div>
  );
}
